import React from 'react';
import ReactHighcharts from 'react-highcharts';
import md5 from 'md5';
import _ from 'lodash';

import colorHelper from '../../lib/colorLuminance';

class ColumnChartWidget extends React.Component {
    static getInitials(user) {
        if (!user) {
            return '';
        }

        let i1 = '';
        let i2 = '';
        let nameArray = [];

        if (user) {
            i1 = user.charAt(0);
            nameArray = user.split(' ');

            if (nameArray.length > 2) {
                i2 = nameArray[nameArray.length - 1].charAt(0);
            } else if (nameArray.length === 2) {
                i2 = nameArray[1].charAt(0);
            }
        }

        return i1 + i2;
    }

    static isBudgetTaken(sold, budget, color) {
        if (budget === 0) {
            return color;
        } else if (sold >= budget) {
            return '#5cb85c';
        }

        return color;
    }

    labelFormatter() {
        if (this.value.type !== 'user' || this.value.displayType === 'text') {
            let name = this.value.name;
            if (name.length > 15) {
                name = `${name.substr(0, 12)}...`;
            }
            return `<span>${name}</span>`;
        }

        if (this.value.displayType === 'picture') {
            return `<div class="user-holder"><div title="${this.value.name}" class="userImage" style="background: ${this.value.bgColor}">
                <div class="initials">
                    <span>${this.value.initials}</span>
                </div>
                <img src="//gravatar.com/avatar/${this.value.hash}?size=100&d=blank&r=x" class="avatar" alt="${this.value.name}"/>
            </div></div>`;
        }

        return `<div class="user-holder"><div title="${this.value.name}" class="userImage" style="background: ${this.value.bgColor}">
            <div class="initials">
                <span>${this.value.initials}</span>
            </div>
            <img src="//gravatar.com/avatar/${this.value.hash}?size=100&d=blank&r=x" class="avatar" alt="${this.value.name}"/>
        </div>${this.value.name.split(' ')[0]}</div>`;
    }

    numberFormatter() {
        const str = this.value.toString().split('.');
        if (str[0].length >= 5) {
            if (str[0].length > 6) {
                // str[0] = str[0].substr(0, 1) + 'M';
                str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
            } else {
                str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
            }
        }
        if (str[1] && str[1].length >= 5) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }

        return str.join(' ');
    }

    dataNumberFormatter() {
        const str = Math.ceil(this.y).toString().split('.');
        if (str[0].length >= 5) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
        }
        if (str[1] && str[1].length >= 5) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }
        return str.join(' ');
    }

    render() {
        const { widget, widgetData, companyProfile, isThumbnail } = this.props;

        const mainColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);
        const lighterMainColor = colorHelper.colorLuminance(companyProfile.colors.mainBg, 0);

        if (isThumbnail) {
            return (<div className="column_chart_widget" />)
        }

        let data, budget;

        if (_.get(widget, 'displayConfig.noSort', false)) {
            data = widgetData;
        } else {
            data = _.sortBy(widgetData, 'value').reverse();
        }

        if (widget.displayConfig && widget.displayConfig.budget) {
            if (widget.displayConfig.budget != null || 0 || '') {
                budget = parseInt(widget.displayConfig.budget, 10);
            }
        }

        if (_.get(widget, 'displayConfig.zeroFilter', false)) {
            data = _.filter(data, (o) => {
                return o.value > 0;
            }); 
        }
        const yBudget = data.map((o) => {
            const _budget = budget || o.budget;

            if (o.value > _budget) {
                return {
                    y: o.value,
                    low: -10000,
                    color: ReactHighcharts.Highcharts.Color(mainColor).setOpacity(0.2).get('rgba'),
                };
            }

            return {
                y: _budget,
                low: -10000,
                color: ReactHighcharts.Highcharts.Color(mainColor).setOpacity(0.2).get('rgba'),
            };
        });

        const yData = data.map((o) => {
            const _budget = budget || o.budget;

            if (o.value >= 1) {
                return {
                    y: o.value,
                    low: -10000,
                    color: ColumnChartWidget.isBudgetTaken(o.value, _budget, mainColor),
                };
            }

            return {
                y: 0,
            };
        });


        const displayType = _.get(widget, 'displayConfig.labelType', 'pictureAndText');

        const xCategories = data.map(o => ({
            name: o.name,
            hash: md5(o.email),
            initials: ColumnChartWidget.getInitials(o.name),
            type: widget.dataConfig.dividedBy,
            bgColor: mainColor,
            displayType,
        }));

        const options = {
            chart: {
                type: 'column',
                width: null,
                height: this.props.rowHeight ? this.props.rowHeight * widget.height : null,
                marginTop: 108,
                marginBottom: -40,
                spacingBottom: 10,
                spacingLeft: 40,
                marginRight: 60,
            },
            tooltip: { enabled: false },
            credits: {
                enabled: false,
            },
            title: {
                text: '',
            },
            xAxis: {
                lineWidth: 0,
                minorGridLineWidth: 0,
                type: 'category',
                minorTickLength: 0,
                tickLength: 0,
                categories: xCategories,
                labels: {
                    useHTML: true,
                    x: 0,
                    formatter: this.labelFormatter,
                    reserveSpace: true,
                    style: { height: '50px' },
                    autoRotation: 0,
                },
            },
            yAxis: {
                allowDecimals: false,
                min: 0,
                max: _.sumBy(yData, 'y') === 0 && _.sumBy(yBudget, 'y') === 0 ? 5 : null,
                gridLineDashStyle: 'solid',
                gridLineColor: lighterMainColor,
                title: {
                    text: null,
                },
                labels: {
                    formatter: this.numberFormatter,
                    style: {
                        color: mainColor,
                        fontWeight: 300,
                        fontSize: 14,
                    },
                    y: 5,
                },
            },
            plotOptions: {
                column: {
                    pointWidth: 50,
                    grouping: false,
                    shadow: false,
                    dataLabels: {
                        enabled: false,
                        formatter: this.dataNumberFormatter,
                        style: {
                            color: 'contrast',
                            textShadow: '0 0 3px contrast',
                            fontWeight: '400',
                        },
                    },
                },
            },
            legend: {
                enabled: false,
            },
            series: [
                {
                    name: '',
                    index: 0,
                    data: yBudget,
                    borderRadius: 5,
                    pointPadding: 0,
                },
                {
                    name: yData,
                    index: 1,
                    data: yData,
                    borderRadius: 5,
                    pointPadding: 0,
                },
            ],
        };

        return (
            <div className="column_chart_widget">
                <ReactHighcharts
                    config={options}
                    isPureConfig
                />
            </div>
        );
    }
}

ColumnChartWidget.propTypes = {
    widget: React.PropTypes.object,
    widgetData: React.PropTypes.array,
    companyProfile: React.PropTypes.object,
    rowHeight: React.PropTypes.number,
};

export default ColumnChartWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/ColumnChartWidget.jsx
 **/